var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 18.0002C5.75226 18.0002 4.55564 17.5261 3.67337 16.6822C2.7911 15.8383 2.29544 14.6937 2.29544 13.5002C2.29544 12.3067 2.7911 11.1621 3.67337 10.3182C4.55564 9.4743 5.75226 9.0002 6.99999 9.0002C7.29467 7.68737 8.15675 6.53368 9.39657 5.79291C10.0105 5.42612 10.6986 5.17174 11.4218 5.04431C12.1449 4.91687 12.8888 4.91887 13.6111 5.0502C14.3334 5.18152 15.0198 5.43959 15.6313 5.80968C16.2427 6.17976 16.7672 6.65461 17.1747 7.20712C17.5823 7.75963 17.8649 8.37898 18.0065 9.02979C18.1481 9.68061 18.1459 10.3502 18 11.0002H19C19.9282 11.0002 20.8185 11.3689 21.4749 12.0253C22.1312 12.6817 22.5 13.5719 22.5 14.5002C22.5 15.4285 22.1312 16.3187 21.4749 16.9751C20.8185 17.6314 19.9282 18.0002 19 18.0002H18",
    stroke: "#0069FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15L12 12L15 15",
    stroke: "#0069FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V21",
    stroke: "#0069FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.2c2a4437293628559f011dda92e9dc44.svg";
export { ForwardRef as ReactComponent };